import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./AddCategory.css";
import { BACKEND_URL } from "../../../config";

function ViewCategory() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [viewData, setViewData] = useState(null);

  const fetchCategories = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api.php?module=category`);
      const data = await res.json();
      if (data.success) setCategories(data.data);
      else setCategories([]);
    } catch (err) { console.log(err); }
  };

  useEffect(() => { fetchCategories(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    await fetch(`${BACKEND_URL}/api.php?module=category`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    fetchCategories();
  };

  useEffect(() => {
    if (viewData) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [viewData]);

  return (
    <div className="admin-page">
      <h2>View Categories</h2>
      <div className="admin-table">
        <table>
          <thead>
            <tr><th>Name</th><th>Parent</th><th>Image</th><th>Status</th><th>Action</th></tr>
          </thead>
          <tbody>
            {categories.map((c) => (
              <tr key={c.id}>
                <td>{c.categoryName}</td>
                <td>
                  {(() => {
                    const pId = c.parentId || c.parent_id;
                    if (!pId || pId === "0" || pId === 0) return "-";
                    return categories.find((p) => String(p.id) === String(pId))?.categoryName || "-";
                  })()}
                </td>
                <td>{c.image ? <img src={c.image?.startsWith("http") ? c.image : `${BACKEND_URL}/${c.image}`} width="60" alt="" /> : "-"}</td>
                <td>{c.status}</td>
                <td className="action-btns">
                  <button className="admin-btn view" onClick={() => setViewData(c)}>View</button>
                  <button className="admin-btn edit" onClick={() => navigate(`/admin/categories/edit/${c.id}`)}>Edit</button>
                  <button className="admin-btn delete" onClick={() => handleDelete(c.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewData && (
        <div className="vm-overlay" onClick={() => setViewData(null)}>
          <div className="vm-box" onClick={(e) => e.stopPropagation()}>

            <div className="vm-header">
              <span className="vm-header-title">Category Details</span>
              <button className="vm-close-btn" onClick={() => setViewData(null)}>✕</button>
            </div>

            <div className="vm-scroll">

              <div className="vm-top-row">
                {viewData.image && (
                  <div className="vm-img-box">
                    <img src={viewData.image?.startsWith("http") ? viewData.image : `${BACKEND_URL}/${viewData.image}`} alt="" />
                  </div>
                )}
                <div className="vm-top-info">
                  <p className="vm-product-name">{viewData.categoryName}</p>
                  <p className="vm-product-sub">Slug: {viewData.slug}</p>
                  <span className={`vm-badge ${viewData.status === "Active" ? "vm-badge-active" : "vm-badge-inactive"}`}>
                    {viewData.status}
                  </span>
                </div>
              </div>

              <div className="vm-info-grid">
                <div className="vm-info-item"><span className="vm-label">Date</span><span className="vm-value">{viewData.date}</span></div>
                <div className="vm-info-item"><span className="vm-label">Status</span><span className="vm-value">{viewData.status}</span></div>
                <div className="vm-info-item">
                  <span className="vm-label">Parent Category</span>
                  <span className="vm-value">
                    {(() => {
                      const pId = viewData.parentId || viewData.parent_id;
                      if (!pId || pId === "0" || pId === 0) return "None";
                      return categories.find((p) => String(p.id) === String(pId))?.categoryName || "None";
                    })()}
                  </span>
                </div>
                <div className="vm-info-item vm-full"><span className="vm-label">Keywords</span><span className="vm-value">{viewData.keywords}</span></div>
              </div>

              <div className="vm-section">
                <p className="vm-section-title">Keywords</p>
                <div className="vm-tags">
                  {viewData.keywords
                    ? viewData.keywords.split(",").map((k, i) => <span key={i} className="vm-tag">{k.trim()}</span>)
                    : "-"}
                </div>
              </div>

            </div>

            <div className="vm-footer">
              <button className="vm-footer-edit" onClick={() => { navigate(`/admin/categories/edit/${viewData.id}`); setViewData(null); }}>Edit</button>
              <button className="vm-footer-delete" onClick={() => { handleDelete(viewData.id); setViewData(null); }}>Delete</button>
              <button className="vm-footer-close" onClick={() => setViewData(null)}>Close</button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default ViewCategory;